import { __awaiter, __generator } from "tslib";
import { AddToCartActionOption } from '@wix/wixstores-client-core/dist/es/src/constants';
import { CartEvents } from '@wix/wixstores-client-core/dist/es/src/types/cart';
import { CartApi } from '../../apis/CartApi/CartApi';
import { ProductsApi } from '../../apis/ProductsApi/ProductsApi';
import { SPECS } from '../../constants';
import { getCartIconControllerConfig } from './getCartIconControllerConfig';
var getCartApi = function (siteStore) {
    return new CartApi({ siteStore: siteStore, origin: 'velo' });
};
var getProductsApi = function (siteStore) {
    return new ProductsApi({ siteStore: siteStore, origin: 'velo' });
};
var migrateToCartApi = function (siteStore) {
    return siteStore.experiments.enabled(SPECS.MIGRATE_VELO_CART_ACTIONS_TO_CART_API);
};
var getCustomTextFields = function (options) {
    var _a;
    return (_a = options.customTextFields) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
        var title = _a.title, value = _a.value;
        return ({
            customText: {
                title: title,
            },
            answer: value,
        });
    });
};
export function createWixcodeExports(context) {
    var _this = this;
    return {
        registerOnCartChangeListener: function (listener) {
            context.siteStore.pubSubManager.subscribe(CartEvents.CHANGED, listener);
        },
        removeProductFromCart: function (cartItemId) { return __awaiter(_this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!migrateToCartApi(context.siteStore)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getCartApi(context.siteStore).fetchCart()];
                    case 1:
                        cart = _a.sent();
                        return [2 /*return*/, getCartApi(context.siteStore).removeItem({ cartId: cart.cartId, cartItemId: Number(cartItemId) })];
                    case 2: return [2 /*return*/, context.siteStore.cartActions.removeItemFromCart(cartItemId).then(function () { return undefined; })];
                }
            });
        }); },
        addCustomItemsToCart: function (customItems) {
            return context.siteStore.cartActions.addCustomItemsToCart(customItems).then(function () { return undefined; });
        },
        addProductsToCart: function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, context.siteStore.cartActions.addProductsToCart(items)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        addToCart: function (productId, quantity, options) {
            if (quantity === void 0) { quantity = 1; }
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!productId) {
                                throw Error("missing productId");
                            }
                            productId = "" + productId;
                            quantity = parseInt("" + quantity, 10);
                            return [4 /*yield*/, context.siteStore.cartActions.addToCart("" + productId, (_a = options.choices) !== null && _a !== void 0 ? _a : {}, quantity, getCustomTextFields(options), AddToCartActionOption.MINI_CART, 'wixcode', function () { return null; }, undefined, undefined, undefined, options)];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        applyCouponToCart: function (couponCode) {
            if (migrateToCartApi(context.siteStore)) {
                return getCartApi(context.siteStore)
                    .fetchCart()
                    .then(function (cart) { return getCartApi(context.siteStore).applyCoupon(cart.cartId, couponCode); });
            }
            return context.siteStore.cartActions.applyCouponToCart(couponCode).then(function () { return undefined; });
        },
        removeCouponFromCart: function () {
            if (migrateToCartApi(context.siteStore)) {
                return getCartApi(context.siteStore)
                    .fetchCart()
                    .then(function (cart) {
                    return getCartApi(context.siteStore).removeCoupon({ cartId: cart.cartId, couponId: cart.appliedCoupon.couponId });
                });
            }
            return context.siteStore.cartActions.removeCouponFromCart().then(function () { return undefined; });
        },
        updateLineItemQuantityInCart: function (cartItemId, quantity) {
            if (migrateToCartApi(context.siteStore)) {
                return getCartApi(context.siteStore)
                    .fetchCart()
                    .then(function (cart) {
                    return getCartApi(context.siteStore).updateItemQuantity({ cartId: cart.cartId, cartItemId: cartItemId, quantity: quantity });
                });
            }
            return context.siteStore.cartActions.updateLineItemQuantityInCart(cartItemId, quantity).then(function () { return undefined; });
        },
        showMinicart: function () {
            if (context.siteStore.isMobile()) {
                throw Error("can't open mini cart in mobile");
            }
            context.siteStore.minicartActions.showMinicart();
        },
        hideMinicart: function () {
            if (context.siteStore.isMobile()) {
                throw Error("can't handle mini cart in mobile");
            }
            context.siteStore.minicartActions.hideMinicart();
        },
        openProductQuickView: function (productId, options) { return __awaiter(_this, void 0, void 0, function () {
            var cartIconControllerConfig, compId, config, product;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cartIconControllerConfig = getCartIconControllerConfig(context);
                        if (context.siteStore.isMobile()) {
                            throw Error('Cannot open quick-view in mobile');
                        }
                        if (!cartIconControllerConfig) {
                            throw Error('No Cart icon config provided');
                        }
                        compId = cartIconControllerConfig.compId, config = cartIconControllerConfig.config;
                        return [4 /*yield*/, getProductsApi(context.siteStore).fetchProductSlug(productId)];
                    case 1:
                        product = _a.sent();
                        if (!product) {
                            throw Error('Product with provided productId does not exist');
                        }
                        return [2 /*return*/, context.siteStore.productActions.quickViewProduct({
                                origin: 'velo',
                                urlPart: product.urlPart,
                                compId: compId,
                                externalId: config.externalId,
                                selectionIds: [],
                                quantity: options === null || options === void 0 ? void 0 : options.quantity,
                            })];
                }
            });
        }); },
    };
}
//# sourceMappingURL=createWixcodeExports.js.map